import * as React from "react"
const SvgFireMini = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 15.235q-2.598 0-4.417-1.818T1.765 9q0-1.926 1.135-3.997t3.168-3.797Q6.773.622 7.504.928q.731.307.731 1.174v.377q0 .525.37.895.369.37.895.37.278 0 .501-.086a.8.8 0 0 0 .355-.26 1 1 0 0 1 .648-.36.8.8 0 0 1 .67.188q1.176 1.028 1.869 2.582.693 1.552.693 3.192 0 2.598-1.819 4.417T8 15.235M3.806 9q0 .69.233 1.322.231.632.744 1.255l-.02-.123a1 1 0 0 1-.01-.082q.07-.439.274-.862t.532-.793L8 6.994l2.453 2.723q.328.37.532.793t.262.862q0 .046-.01.103t-.02.123q.459-.498.718-1.172T12.194 9q0-.975-.301-1.902a6.1 6.1 0 0 0-.869-1.71 4 4 0 0 1-.748.29 3 3 0 0 1-.776.107q-1.035 0-1.888-.572a3.2 3.2 0 0 1-1.226-1.564Q5.11 4.939 4.458 6.286T3.806 9M8 10.01l-.936 1.082q-.155.196-.242.404a1.1 1.1 0 0 0-.087.435q0 .53.37.896.368.367.897.367t.896-.368.367-.897a1.3 1.3 0 0 0-.076-.424 1.3 1.3 0 0 0-.25-.41z" />
  </svg>
)
export default SvgFireMini
